import { render, staticRenderFns } from "./PersistPlatformTypeView.vue?vue&type=template&id=5420bf6c"
import script from "./PersistPlatformTypeView.vue?vue&type=script&lang=ts"
export * from "./PersistPlatformTypeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports